export const ADD_OPTION = "ADD_OPTION";
export const REMOVE_OPTION = "REMOVE_OPTION";
export const SET_OPTION = "SET_OPTION";
export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const SET_LANGUAGE_KEY = "SET_LANGUAGE_KEY";
export const ADD_SUB_OPTION = "ADD_SUB_OPTION";
export const REMOVE_SUB_OPTION = "REMOVE_SUB_OPTION";
export const SET_SUB_OPTION = "SET_SUB_OPTION";
export const SET_OPTION_OTHER_TEXT = "SET_OPTION_OTHER_TEXT";
export const SET_SUB_OPTION_OTHER_TEXT = "SET_SUB_OPTION_OTHER_TEXT";
export const VALIDATE_SECTION = "VALIDATE_SECTION";
export const CLEAR_QUESTION = "CLEAR_QUESTION";
export const CLEAR_SUB_OPTIONS = "CLEAR_SUB_OPTIONS";
export const SET_QUESTION_SCORE = "SET_QUESTION_SCORE";
export const ADD_OPTION_FILE = "ADD_OPTION_FILE";
export const REMOVE_OPTION_FILE = "REMOVE_OPTION_FILE";
export const ADD_SUB_OPTION_FILE = "ADD_SUB_OPTION_FILE";
export const REMOVE_SUB_OPTION_FILE = "REMOVE_SUB_OPTION_FILE";
export const SET_OPTION_ERROR = "SET_OPTION_ERROR";
export const CLEAR_OPTION_ERROR = "CLEAR_OPTION_ERROR";
export const ADD_OPTION_ITEM = "ADD_OPTION_ITEM";
export const REMOVE_OPTION_ITEM = "REMOVE_OPTION_ITEM";
export const ADD_SUB_OPTION_ITEM = "ADD_SUB_OPTION_ITEM";
export const REMOVE_SUB_OPTION_ITEM = "REMOVE_SUB_OPTION_ITEM";
